export default __webpack_public_path__ + "static/Overlay-Carousel-BG-c5dd7b7736d5822aa4c3153f9bf6f842.png";